import styled from 'styled-components';

export const ColumnStyled = styled.div
  .attrs({ className: 'relative flex items-center justify-between h-10 px-4 w-96' },
  )<{ isFixed?: boolean, opacity?: number }>`
  cursor: ${({ isFixed }) => isFixed ? 'default' : 'pointer'};
  opacity: ${({ opacity }) => opacity ?? 1};

  &:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.black10};
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 10%;
    display: ${({ isFixed }) => isFixed ? 'none' : 'block'};
    background-image: radial-gradient(#B7B7B7 20%, transparent 30%);
    background-size: 3px 3px;
    width: 6px;
    height: 80%;
  }
`;
